import api from "./api";

export const getCountries = async (): Promise<any> => {
    try {
        const response = await api.get(`/countries`);

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Countries");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getStatesByCountry = async (country_id: string): Promise<any> => {
    try {
        const response = await api.get(`/states/${country_id}`);

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get States");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};

export const getCitiesByState = async (state_id: string): Promise<any> => {
    try {
        const response = await api.get(`/cities/${state_id}`);

        if (response.data.status) {
            return response.data.data;
        } else {
            throw new Error(response.data.message); // Throw error with message
        }
    } catch (error) {
        if (error instanceof Error) {
            throw new Error(error.message || "Unable to get Cities");
        } else {
            throw new Error("An unknown error occurred");
        }
    }
};